import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import HomePage from './pages/Home/HomePage'
import ApplicationForm from './pages/ApplicationForm/ApplicationForm'
import JobDetails from './pages/JobDetails/JobDetails'
import Success from './pages/Success/SuccesPage'


export default function Router() {
    const router = createBrowserRouter([
        {
            path: '/',
            element: <HomePage />,
        },
          {
            path: '/ApplicationForm',
            element: < ApplicationForm/>
        },
        {
            path: `/JobDetails`,
            element: <JobDetails />
        },
        {
            path: '/Success',
            element: <Success />
        },
    ])
    return <RouterProvider router={router} />
}